const initialState = {
  availableStates: [],
  autoPopulated: false,
};

const partnerFilters = (state = initialState, action) => {
  switch (action.type) {
    case "SET_AVAILABLE_PARTNER_STATES":
      return {
        ...state,
        availableStates: action.states,
        autoPopulated: true,
      };
    case "CLEAR_AVAILABLE_PARTNER_STATES":
      return {
        ...state,
        availableStates: [],
        autoPopulated: false,
      };
    default:
      return state;
  }
};

export default partnerFilters;
